import { _fetch as fetchSecure } from '@hobs/utils/fetch';
import { CORDATA, CLEAR, UPDATE, EXPORTCOR } from '@hobs/constants/cor';

export function getCorInformation() {
  return dispatch => {
    dispatch(request());

    return fetchSecure(
      'StatementOfRequirements/SendingNationCorUnitInformation'
    )
      .then(response => {
        if (response && response.status === 200) {
          dispatch(success(response.payload));
          return { success: true, ...response };
        } else {
          dispatch(failure(response.toString()));
          return { success: false, ...response };
        }
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };

  function request() {
    return { type: CORDATA.REQUEST };
  }
  function success(response) {
    return { type: CORDATA.SUCCESS, payload: response };
  }
  function failure(error) {
    return { type: CORDATA.FAILURE, error };
  }
}

export function updateCorInformation(values) {
  return dispatch => {
    dispatch(request());

    return fetchSecure(
      'StatementOfRequirements/SendingNationCorUnitInformation',
      { body: values, method: 'PUT' }
    )
      .then(response => {
        if (response && response.status === 200) {
          dispatch(success());
          return { success: true, ...response };
        } else {
          dispatch(failure(response.toString()));
          return { success: false, ...response };
        }
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };

  function request() {
    return { type: UPDATE.REQUEST };
  }
  function success() {
    return { type: UPDATE.SUCCESS };
  }
  function failure(error) {
    return { type: UPDATE.FAILURE, error };
  }
}

export function clearCorData() {
  return dispatch => {
    dispatch({ type: CLEAR.SUCCESS });
  };
}

export function exportCor() {
  return dispatch => {
    dispatch(request());
    return fetchSecure('ConceptOfRequirements/Export')
      .then(response => {
        if (response) {
          dispatch(success());
          return { success: true, blob: response };
        } else {
          dispatch(failure(response.toString()));
          return { success: false, ...response };
        }
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };

  function request() {
    return { type: EXPORTCOR.REQUEST };
  }
  function success() {
    return { type: EXPORTCOR.SUCCESS };
  }
  function failure(error) {
    return { type: EXPORTCOR.FAILURE, error };
  }
}
